<div class="insured-card">
    <div class="insured-card-accent"></div>
    <div class="insured-card-body">
        <div class="insured-field">
            <span class="insured-label">Tipo:</span>
            <span class="insured-value">Vehículo</span>
        </div>
        <div class="insured-field">
            <span class="insured-label">Matrícula:</span>
            <span class="insured-value">{{data.registration}}</span>
        </div>
        <div class="insured-field">
            <span class="insured-label">Categoría:</span>
            <span class="insured-value">{{data.category}}</span>
        </div>
        <div class="insured-field">
            <span class="insured-label">Fecha matriculación:</span>
            <span class="insured-value">{{data.registrationDate | date: 'dd/MM/yyyy'}}</span>
        </div>
        <div class="insured-field">
            <span class="insured-label">Clase:</span>
            <span class="insured-value">{{data.clas}}</span>
        </div>
        <div class="insured-field">
            <span class="insured-label">Tipo:</span>
            <span class="insured-value">{{data.type}}</span>
        </div>
    </div>
</div>
